<script lang="ts">
  import type {ITransactionProgress} from "$lib/interfaces/ITransactionProgress";
  import {TransactionOrderProgressStatus} from "$lib/enums/transaction-order-progress-status";
  import OrderProgressItemIcon from "$lib/components/TransactionDetails/OrderProgress/OrderProgressItemIcon.svelte";

  interface Props {
    progress: ITransactionProgress;
  }

  let { progress }: Props = $props();
  const isCompleted = progress.status === TransactionOrderProgressStatus.REACHED;
</script>

<div class="flex items-start space-x-4">
  <OrderProgressItemIcon {isCompleted}/>
  <div>
    <p class="font-semibold">{progress.title}</p>
    {#if progress?.updatedAt}
      <p class="text-sm text-gray-500">Updated at {progress.updatedAt}</p>
    {/if}
    {#if progress?.message}
      <p class="text-xs text-gray-400">{progress.message}</p>
    {/if}
  </div>
</div>
